import {
  Action,
  BaseRequestAction,
  BaseRequestSuccessAction,
  BaseRequestFailureAction,
} from "types";
import * as actions from "./getStartedRefreshActions";
import { State, Data } from "./types";

const ACTION_HANDLERS = {
  [actions.GET_STARTED_REFRESH_REQUEST]: (
    state: State,
    _action: BaseRequestAction
  ): State => ({
    ...state,
    loading: true,
    loaded: !!state.data,
    error: null,
  }),
  [actions.GET_STARTED_REFRESH_REQUEST_SUCCESS]: (
    state: State,
    action: BaseRequestSuccessAction<Data>
  ): State => ({
    ...state,
    loading: false,
    loaded: true,
    error: null,
    data: action.data,
  }),
  [actions.GET_STARTED_REFRESH_REQUEST_FAILURE]: (
    state: State,
    action: BaseRequestFailureAction
  ): State => ({
    ...state,
    loading: false,
    loaded: false,
    error: action.error,
    data: null,
  }),
};

const initialState: State = {
  loaded: false,
  loading: false,
  error: null,
  data: null,
};

export default function getStartedRefreshReducer(
  state: State = initialState,
  action: Action
): State {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
